import type { FaireProductEntity } from "../../entity_types/product";

export const p_g7ahrh25xa: FaireProductEntity = {
  token: "p_g7ahrh25xa",
  type: "product",
  name: "Sequence coat hook - Revolve",
  brandToken: "b_5v70ir5zqm",
  brandName: "Misewell",
  imageUrl:
    "https://cdn.faire.com/fastly/86a7da3f50b58350f4acf44f8de74fdf13cb3597682e393ff495d19c8b563095.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b30e05467473fc8308130331f55e7777a3ca4aa8dccf2be4ee6f8759b44e4eab.jpeg",
    "https://cdn.faire.com/fastly/4c161461333a6e3f3ec952bfad2febcd8ae7dd742f7799ce8f9c7f237dbb2d77.jpeg",
    "https://cdn.faire.com/fastly/ac5ce6af03f8c234d999b1f01e2ae9cd8e7402638e269b6626e16e204e7a6215.jpeg",
    "https://cdn.faire.com/fastly/42bce19433e8404d202e2ccd2f04d0bfee3761caffe857f49aa4a52654b1a108.jpeg",
    "https://cdn.faire.com/fastly/8a99c18d5fbe519bafb62970245b83ddce621b5575a13e235481308debba4f3d.jpeg",
    "https://cdn.faire.com/fastly/e1500bd085f7e6875b7fe754f25dce16ddb507f45c4e53e7905be7407cc054dd.jpeg",
    "https://cdn.faire.com/fastly/d391571ffb0f8116e53265f392b1bd7b9327a79b28a81a989a19401e76793ad0.jpeg",
    "https://cdn.faire.com/fastly/b628fc1fa025bc7187b6617638dd6bd3659ba1ccdf585ca88c7fd96e358304c3.jpeg",
    "https://cdn.faire.com/fastly/b0f114b7f445c585f7c18f0d982260a302e88643b82619b752464ac7434750f1.jpeg",
    "https://cdn.faire.com/fastly/4faa5c120d02d76ee9f8c628856db99e13ed6160a70d45a91304d2d056d6c941.jpeg",
    "https://cdn.faire.com/fastly/8a70da7d1a53cbb3aff6df9dc846f06b0f9646955bb1978da9bd3933168210a5.jpeg",
    "https://cdn.faire.com/fastly/f58178d93d4b4e51074348519502984d47e8d51491095ff608e2c3d726ab5226.jpeg",
  ],
  priceDollars: 19.5,
  description:
    "Alternate and repeat these ceramic coat hooks to create a functional piece of art. The hooks are hand-made out of stoneware, introducing warmth and richness to entryways, bedrooms and bathrooms. Mounting hardware included. Each hook is made by hand in our ceramic studio.\n\n• Max weight 8lbs.\n• 3W x 3H x 1.5D\n• Made in USA\n• (Milwaukee)",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:08.831Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
